import React from "react";
import FormProvider from "@providers/FormProvider";
import { usePageContext } from "@providers/PageProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import { Form, useFormik } from "formik";
import Tabs from "@components/Tabs";
import cx from "classnames";
import Card from "./CardEvent";
import useSwiper from "@hooks/useSwiper";
import Swiper from "@components/Swiper";
import Icons from "@gstyles/styleguide/icons";
import styles from "./Events.module.scss";
import _ from "lodash";
import TourService from "@services/TourService";
import helper, { discoverPage } from "@utils/helper";

const ContentTab = ({ name = "", data }: any) => {
  const [reachEnd, $reachEnd] = React.useState(false);
  const [reachBeginning, $reachBeginning] = React.useState(true);
  useSwiper(`.event-swiper-${name}`, {
    speed: 1000,
    spaceBetween: 32,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1080: {
        slidesPerView: 2,
      },
      1600: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: `.swiper-arrow-next-events-${name}`,
      prevEl: `.swiper-arrow-prev-events-${name}`,
    },
    on: {
      reachEnd: () => {
        _.debounce(() => {
          $reachEnd(true);
        }, 500)();
      },
      slideChange: (swiper) => {
        if (swiper) {
          $reachBeginning(false);
          $reachEnd(false);
        }
      },
      reachBeginning: () => {
        _.debounce(() => {
          $reachBeginning(true);
        }, 500)();
      },
    },
  });
  return (
    <div className={cx("inner-large", styles.swiperWrapper)}>
      {/* <div className={cx("inner-large", styles.events)}> */}
      <Icons
        name="chevron-right-outline"
        color="#F7EEDF"
        className={cx(
          `swiper-arrow-prev-events-${name}`,
          styles.prevArrowIconMb,
          {
            invisible: reachBeginning,
            visible: !reachBeginning,
          }
        )}
      />
      <Icons
        name="arrow-long-narrow-right"
        color="#2e281f"
        className={cx(
          `swiper-arrow-prev-events-${name}`,
          styles.prevArrowIcon,
          {
            invisible: reachBeginning,
            visible: !reachBeginning,
          }
        )}
      />
      <Swiper className={cx(`event-swiper-${name}`, styles.swiper)}>
        {_.map(data, (item: any, index: number) => {
          return (
            <Card
              style={{ minWidth: "340px" }}
              className={cx("swiper-slide")}
              {...item}
              key={`card_${index}`}
              map="off"
            />
          );
        })}
      </Swiper>
      <Icons
        name="arrow-long-narrow-right"
        color="#2e281f"
        className={cx(
          `swiper-arrow-next-events-${name}`,
          styles.nextArrowIcon,
          {
            invisible: reachEnd,
            visible: !reachEnd,
          }
        )}
      />
      <Icons
        name="chevron-right-outline"
        color="#F7EEDF"
        className={cx(
          `swiper-arrow-next-events-${name}`,
          styles.nextArrowIconMb,
          {
            invisible: reachEnd,
            visible: !reachEnd,
          }
          // nextIconVisible
        )}
      />
    </div>
  );
};
const ContentView = ({ slug, tours }: any) => {
  return (
    <>
      {!_.isEmpty(tours) && (
        <ContentTab name={slug} data={discoverPage.formatTours(tours)} />
      )}
    </>
  );
};

const View = () => {
  const { i18n } = useTranslationContext();
  const { tourCategories, hotel } = usePageContext();
  const categories = _.compact(_.map(tourCategories, helper.formatCategory));
  const form = useFormik({
    enableReinitialize: true,
    initialValues: {
      tab: _.get(categories, "0.slug"),
    },
    onSubmit: async () => {
      return true;
    },
  });
  const [TABS, $TABS]: any = React.useState([]);
  React.useEffect(() => {
    const result: any = [];
    _.map(categories, async (cat, index) => {
      // REFACTOR: nếu có thể query được category có locations thì chỉnh lại đoạn code này cho phù hợp.
      const res = await TourService.find({
        locale: i18n.language,
        populate: "deep",
        filters: {
          category: {
            slug: {
              $eq: cat.slug,
            },
          },
          hotel: {
            slug: {
              $eq: hotel,
            },
          },
        },
      });
      const tours = _.get(res, "data", []);
      if (!_.isEmpty(tours)) {
        result.push({
          label: cat.name,
          key: cat.slug,
          value: cat.slug,
          children: <ContentView slug={cat.slug} tours={tours} />,
        });
      }
      if (categories.length === index + 1) {
        _.debounce(() => {
          $TABS(result);
        }, 300)();
      }
    });
  }, [categories, hotel, i18n.language]);
  return (
    <section data-scroll-section className={styles.section}>
      <FormProvider form={form}>
        <Form>
          {!_.isEmpty(TABS) && (
            <Tabs
              theme="light"
              name="tab"
              items={TABS}
              // defaultActiveKey={"tour"}
              selectStyle={{ boxSelect: styles.boxSelect }}
            />
          )}
        </Form>
      </FormProvider>
    </section>
  );
};
export default View;
